import { Loader } from '@comall-backend-builder/core/lib/loaders';
import { ApiRequestConfig, api } from '@comall-backend-builder/core/lib/services/api';

// 直播商品
export const LiveProductLoader: Loader = {
    get: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = '/live/products';

        // 删除无用参数
        if (params && params.roomid) {
            params.perPage = 50;
            params.status = 'APPROVED';
            delete params.roomid;
        }

        // 删除无用参数
        if (params && params.activeTab) {
            delete params.activeTab;
        }

        // sku可能是用空格分割，需要使用逗号分割
        if (params && params.skuList) {
            let str = params.skuList.replace(/\s+/g, ',');
            params.skuList = str;
        }

        const response: any = await api.get(params, config);
        return response;
    },
};
